module.exports = "https://img.xiyuyouxi.com/saas/img/mine_menu7.20e07016.png";